module.exports = __webpack_public_path__ + "img/icone-bing.5e4e5382.png";